import React from 'react';
import { EmptyState } from '../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { GainLossDetailsSkeleton } from '../GainLossDetailsSkeleton/GainLossDetailsSkeleton';

interface Props {
  title: string;
}

export const GainLossDetailsEmpty = ({ title }: Props) => {
  return (
    <GainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <EmptyState />
      </Box>
    </GainLossDetailsSkeleton>
  );
};
